<script setup lang="ts">
import { inject } from "vue";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/vue";
import PromoBannerSlide from "~/templates/elements/PromoBannerSlide.vue";
import SvgIcon from "~/templates/elements/SvgIcon.vue";
import { mapNodes, getId } from "~/utils/helper/magnolia";
import { contentToTailwindClasses } from "~/utils/helper/tailwind";
import { screens } from "~/tailwind.config.screens";

const promoBanner = inject("pagePromoBanner", {});

const backgroundColor = promoBanner?.value?.backgroundColor ?? "darkBlue";
const textColor =
  backgroundColor === "red" ||
  backgroundColor === "deepBlue" ||
  backgroundColor === "darkBlue" ||
  backgroundColor === "magenta" ||
  backgroundColor === "black"
    ? "text-base-01"
    : "text-base-02";
const columns = computed(() => mapNodes(promoBanner.value?.columns));
const swiper = ref(null);
const slideCount = computed(() => columns.value?.length);
const { isMobile } = useDevice();

const onSwiper = (swiperInstance) => {
  swiper.value = swiperInstance;
  canSlide.value = !swiperInstance?.isLocked;
};
const canSlide = ref(isMobile.value && slideCount.value > 1);
const onBreakpoint = (swiperInstance) => (canSlide.value = !swiperInstance?.isLocked);
const onClickNext = () => swiper?.value?.slideNext();
const onClickPrev = () => swiper?.value?.slidePrev();
</script>

<template>
  <div
    v-if="slideCount > 0"
    :class="[contentToTailwindClasses({ backgroundColor }), textColor]"
    class="promo-banner flex w-full px-2 py-1.5"
  >
    <Swiper
      class="container"
      loop
      :modules="[Autoplay]"
      :slides-per-view="1"
      :autoplay="{
        delay: promoBanner?.interval,
        disableOnInteraction: true,
      }"
      :breakpoints="{
        [parseInt(screens.md)]: {
          slidesPerView: 3,
          allowTouchMove: false,
        },
      }"
      @swiper="onSwiper"
      @breakpoint="onBreakpoint"
    >
      <SwiperSlide v-for="column in columns" :key="getId(column)" class="promo-banner-slide">
        <PromoBannerSlide :column="column" />
      </SwiperSlide>
      <div
        v-if="canSlide"
        class="swiper-btn absolute left-1 top-1/2 z-10 -translate-y-1/2"
        @click="onClickPrev"
      >
        <SvgIcon name="Arrow-Up" class="h-5 w-5 -rotate-90" />
      </div>
      <div
        v-if="canSlide"
        class="swiper-btn absolute right-1 top-1/2 z-10 -translate-y-1/2"
        @click="onClickNext"
      >
        <SvgIcon name="Arrow-Up" class="h-5 w-5 rotate-90" />
      </div>
    </Swiper>
  </div>
</template>

<style scoped>
/* Necessary to define the styles with @apply to work on the slider element. */
.promo-banner-slide {
  @apply flex items-center justify-center;
  @apply w-full md:w-1/3 md:flex-1;
}
</style>
